/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.13.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetKindFromJSON, TargetKindToJSON, } from './TargetKind';
/**
 * Check if a given object implements the TargetSnapshot interface.
 */
export function instanceOfTargetSnapshot(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function TargetSnapshotFromJSON(json) {
    return TargetSnapshotFromJSONTyped(json, false);
}
export function TargetSnapshotFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'kind': TargetKindFromJSON(json['kind']),
        'externalHost': json['external_host'] == null ? undefined : json['external_host'],
    };
}
export function TargetSnapshotToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'kind': TargetKindToJSON(value['kind']),
        'external_host': value['externalHost'],
    };
}
